/**
 * v-throttle 节流
 */
export default {
    name: 'throttle',
    inserted: function (el, binding) {
        try {
            let fn,
                event = 'click',
                time = 1500;
            if (typeof binding.value == 'function') {
                fn = binding.value;
            } else {
                [fn, event, time] = binding.value;
            }
            /**
             * el.preTime 记录上次触发的时间
             * 每次触发比较nowTime（当前时间） 和 el.preTime 的差是否大于指定的时间段！
             */
            el.addEventListener(event, () => {
                const nowTime = new Date().getTime();
                if (!el.preTime || nowTime - el.preTime > time) {
                    //console.log(!el.preTime, nowTime - el.preTime, nowTime - el.preTime > time);
                    el.preTime = nowTime;
                    fn();
                }
            });
        } catch (error) {
            console.log('节流指令---error==>', error);
        }
    },
    unbind() {},
};
